var exports = {
  "B3": "HeaderContainer__8opdVR",
  "DZ": "Heading__Ab0J5m",
  "lX": "HeaderActions__nThyKu",
  "xI": "ContentContainer__HUiYLU",
};

module.exports = exports;
